var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganicFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3.87A12.62 12.62 0 0 0 12.43 0 15.78 15.78 0 0 0 7.2.91a10 10 0 0 0-5.65 5.76 17.16 17.16 0 0 0-1 7.16c.1.59.53 1.56.94 1.15s-.28-.26-.35-1.59A17.1 17.1 0 0 1 2.36 7 9.24 9.24 0 0 1 7.6 2a15.13 15.13 0 0 1 4.81-.82 12 12 0 0 1 7.68 3.44c2.16 1.91 3.11 6.35 2.56 9.52a.34.34 0 0 0 .67.13c.68-3.41-.21-8.18-2.57-10.4Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47 19.14c-.49-.08-1.29-3.17-2-2.92-.5.17 0 1.86.29 2.33s1.1 1.36 1.73 1.27a.34.34 0 0 0-.02-.68Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86 22c-1.63-1.05-1.65-1.44-2.08-1.21s.32 1.11.65 1.51a3.23 3.23 0 0 0 1.26.87c.57.22 1.93.49 1.93-.12 0-.49-.26-.14-1.76-1.05Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.48 22.53c-5.13.58-4.56.49-4.77.69s-.16.43.27.54c.28.08 1.3.2 1.55.24 2.51 0 2.69-.76 3-.79a.34.34 0 0 0-.05-.68Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05 20.09c-1 1.14-3 1.8-2.73 2.24 0 .06.08.19.25.18a6.73 6.73 0 0 0 2-.66c.51-.33 1.28-1.16 1.18-1.76a.34.34 0 0 0-.7 0Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.59 16a.35.35 0 0 0-.34.34c0 .09-1.63 2.58-1.66 2.66s-.06.34 0 .4a.34.34 0 0 0 .57-.05 3.47 3.47 0 0 0 1.45-1.57c.29-.63.6-1.78-.02-1.78Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.65 13.22c.83-.51 1.48-.64 1.24-1.08a.35.35 0 0 0-.47-.14c-.46.23-.92.36-1.36.6a7.39 7.39 0 0 0-3.17 4.4 9.12 9.12 0 0 0-5.12-7.14.3.3 0 0 0-.29.52c2.89 1.83 4.42 5.67 5 9 0 .28 0 .56-.06.84a.32.32 0 0 0 .27.33c.58 0 .17-.94 1.5-3.84a8.76 8.76 0 0 1 2.46-3.49Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9a1 1 0 0 0-.48-1c-.37-.18-1-.09-3 0a7.41 7.41 0 0 0-2.53.55c-2.09 1-3.85 3.83-3.1 6.21a.3.3 0 0 0 .58-.16c-.54-2 1.15-4.4 2.93-5.09a7.81 7.81 0 0 1 2.21-.37c2.52-.13 2-.12 2.27-.06a19.71 19.71 0 0 1-1.45 4 4.5 4.5 0 0 1-3.56 2.49.34.34 0 0 0 0 .68 5.31 5.31 0 0 0 4.35-2.68A15.43 15.43 0 0 0 21 9Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 14.36c-.4.68-1.39.37-2-.14-1-.86-1.42-2.87-1.93-4.25a11.31 11.31 0 0 1-.65-1.49 6.52 6.52 0 0 1 2.24-.31 4.8 4.8 0 0 1 4 3.15.34.34 0 1 0 .63-.24 5.67 5.67 0 0 0-4.4-3.92 5.76 5.76 0 0 0-2.64.21c-.58.16-1.14.4-1.11 1a2.1 2.1 0 0 0 .29.7c1.3 2.84 1.22 3 1.76 4.1 1.36 2.64 3.67 2.77 4.36 1.5a.3.3 0 0 0-.55-.31Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganicFood);
export default __webpack_public_path__ + "static/media/organic-food.945d041d442d68582aa798337db874a1.svg";
export { ForwardRef as ReactComponent };